import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import './VolunteerTasks.css'
import LoadingScreen from '../components/LoadingScreen'
import alert from '../utils/alertService'

const VolunteerTasks = () => {
  const history = useHistory()
  const [tasks, setTasks] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [statusFilter, setStatusFilter] = useState('')

  useEffect(() => {
    fetchTasks()
  }, [statusFilter])

  const fetchTasks = async () => {
    try {
      const token = localStorage.getItem('access_token')
      let url = '/api/volunteer/tasks'
      if (statusFilter) {
        url += `?status=${statusFilter}`
      }

      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })

      if (response.ok) {
        const data = await response.json()
        setTasks(data.tasks || [])
      } else {
        setError('Failed to load tasks')
      }
    } catch (err) {
      setError('Network error')
    } finally {
      setLoading(false)
    }
  }

  const updateTaskStatus = async (taskId, newStatus) => {
    try {
      const token = localStorage.getItem('access_token')
      const response = await fetch(`/api/volunteer/tasks/${taskId}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ status: newStatus })
      })

      if (response.ok) {
        fetchTasks()
      } else {
        alert.error('Failed to update task')
      }
    } catch (err) {
      alert.error('Network error')
    }
  }

  if (loading) {
    return <LoadingScreen message="Loading Tasks" />
  }

  return (
    <div className="volunteer-tasks-container">
      <header className="page-header">
        <h1>My Tasks</h1>
        <button onClick={() => history.push('/volunteer-dashboard')}>← Back</button>
      </header>

      <main className="tasks-main">
        <div className="filter-section">
          <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
            <option value="">All Status</option>
            <option value="pending">Pending</option>
            <option value="in_progress">In Progress</option>
            <option value="completed">Completed</option>
          </select>
        </div>

        {error && <div className="error-message">{error}</div>}

        <div className="tasks-list">
          {tasks.length > 0 ? (
            tasks.map((task) => (
              <div key={task.id} className="task-card">
                <h3>{task.task_type || 'General Task'}</h3>
                <p>{task.task_description || 'No description'}</p>
                {task.related_test_title && (
                  <p><strong>Related Test:</strong> {task.related_test_title}</p>
                )}
                <div className="task-footer">
                  <span className={`status-badge status-${task.status}`}>{task.status}</span>
                  <div className="task-actions">
                    {task.status === 'pending' && (
                      <button onClick={() => updateTaskStatus(task.id, 'in_progress')}>
                        Start Task
                      </button>
                    )}
                    {task.status === 'in_progress' && (
                      <button onClick={() => updateTaskStatus(task.id, 'completed')}>
                        Mark Complete
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="no-tasks">No tasks assigned</p>
          )}
        </div>
      </main>
    </div>
  )
}

export default VolunteerTasks

